import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RouterDto, FirmwareUpdateState, VpnLinkedState } from '../../api/core';
import {devices} from '../devices.reducer';
import {getEnumKeyByEnumValue} from '../../shared/function/enum-lookup';

export enum CombinedState {
    CertDownload = 'CERT_DOWNLOAD',
    Grace = 'GRACE',
    Init = 'INIT',
    Invalid = 'INVALID',
    Normal = 'NORMAL',
    NormalRenewal = 'NORMAL_RENEWAL',
    Registered = 'REGISTERED',
    FwDownloading = 'FW_DOWNLOADING',
    Linked = 'LINKED',
    Reserved = 'RESERVED',
    CertRequested = 'CERT_REQUESTED',
    RequestExpired = 'REQUEST_EXPIRED',
}

@Component({
    selector: 'liebherr-device-state',
    templateUrl: 'device-state.component.html',
    styleUrls: ['device-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeviceStateComponent implements OnChanges {
    @Input() device?: RouterDto;

    stateData$ = new BehaviorSubject<{ state?: string; styleClass?: string } | undefined>(undefined);

    STATE = CombinedState;

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.device) {
            this.updateStateData();
        }
    }

    private updateStateData() {
        const state = this.getCombinedState();
        const styleClass = this.getStyleClass(state);

        this.stateData$.next({ state, styleClass });
    }

    private getCombinedState() {
        let state: CombinedState | undefined;
        if (
            this.device?.firmwareUpdateState === FirmwareUpdateState.Downloading ||
            this.device?.firmwareUpdateState === FirmwareUpdateState.ForcedDownloading
        ) {
            state = CombinedState.FwDownloading;
        } else if (this.device?.vpnState === VpnLinkedState.Linked) {
            if (this.device?.online) {
                state = CombinedState.Linked;
            } else {
                state = CombinedState.Reserved;
            }
        } else {
            // @ts-ignore
            state = CombinedState[getEnumKeyByEnumValue<CombinedState>(CombinedState , this.device?.routerInitState)];
        }
        return state;
    }

    private getStyleClass(state?: CombinedState) {
        let styleClass: string | undefined;
        switch (state) {
            case CombinedState.CertDownload:
            case CombinedState.Init:
            case CombinedState.Registered:
            case CombinedState.CertRequested:
            case CombinedState.RequestExpired:
            case CombinedState.Reserved:
            case CombinedState.FwDownloading: {
                styleClass = 'neutral';
                break;
            }
            case CombinedState.Grace:
            case CombinedState.Invalid: {
                styleClass = 'invalid';
                break;
            }

            case CombinedState.Normal:
            case CombinedState.NormalRenewal:
            case CombinedState.Linked: {
                styleClass = 'valid';
                break;
            }

            default: {
                break;
            }
        }

        return styleClass;
    }
}
